//tab section
const tabButtons = document.querySelectorAll(".tab-btn");

tabButtons.forEach((tab) => {
  tab.addEventListener("click", () => tabClicked(tab));
});

function tabClicked(tab) {
  tabButtons.forEach((tab) => {
    tab.classList.remove("active");
  });
  tab.classList.add("active");

  const contents = document.querySelectorAll(".content");

  contents.forEach((content) => {
    content.classList.remove("active");
  });

  const contentId = tab.getAttribute("content-id");
  const contentSelected = document.getElementById(contentId);

  contentSelected.classList.add("active");
  //console.log(contentId)
}

//Dummy sold start //

document.addEventListener("DOMContentLoaded", function () {
  function getRandomValue(values) {
    const index = Math.floor(Math.random() * values.length);
    return values[index];
  }

  function updateSoldValues() {
    const flashSoldElement = document.querySelector(".bls__flash-sold");
    if (flashSoldElement) {
      const soldValues = flashSoldElement
        .getAttribute("data-flash-sold")
        .split(",");
      const hoursValues = flashSoldElement
        .getAttribute("data-flash-hours")
        .split(",");

      const sold = getRandomValue(soldValues);
      const hours = getRandomValue(hoursValues);
      const soldValuesElement = flashSoldElement.querySelector(".sold-values");

      if (soldValuesElement) {
        soldValuesElement.textContent = `${sold} sold in last ${hours} hours`;
      }
    }
  }

  // Update the values when the page is loaded
  updateSoldValues();
});
//Dummy sold end //

//Dummy visitors start //

document.addEventListener("DOMContentLoaded", function () {
  const options = {
    visitors: ".bls__visitors",
  };

  const theme = {
    eventVisitors: function () {
      const e = document.querySelector(options.visitors);
      if (!e) return;

      const t = Number(e.getAttribute("data-count-range-max"));
      const r = Number(e.getAttribute("data-count-range-min"));
      const o = Number(e.getAttribute("data-view-duration"));

      function updateVisitorCount() {
        const count = Math.floor(Math.random() * (t - r + 1)) + r;
        document.querySelector(".bls__visitor-count").innerHTML = count;
      }

      updateVisitorCount();
      setInterval(updateVisitorCount, 1000 * o);

      e.style.display = "block";
    },
  };

  theme.eventVisitors();
});

//product personalisation
document.addEventListener("DOMContentLoaded", () => {
  const personalisationCheckbox = document.querySelector(
    "#personalisation-checkbox"
  );
  const personalisationValueDiv = document.querySelector(
    ".personalisation-value"
  );
  const personalisationTextArea = document.querySelector("#allergies");

  if (personalisationCheckbox && personalisationValueDiv) {
    personalisationCheckbox.addEventListener("change", () => {
      if (personalisationCheckbox.checked) {
        personalisationValueDiv.classList.add("active");
      } else {
        personalisationValueDiv.classList.remove("active");
      }
    });
  }
});

// Function to add event listener to checkbox and toggle active class

document.addEventListener("DOMContentLoaded", function () {
  function addCheckboxListener(checkboxSelector) {
    const checkbox = document.querySelector(checkboxSelector);
    if (checkbox) {
      checkbox.addEventListener("change", function () {
        if (this.checked) {
          this.classList.add("active");
        } else {
          this.classList.remove("active");
        }
      });
    }
  }

  addCheckboxListener('.product-gift-wrap input[type="checkbox"]');
  addCheckboxListener("#personalisation-checkbox");
});

// Grid mode change
const options = {
  gridMode: ".grid-mode-show-type-products .grid-mode",
};
document.querySelectorAll(options.gridMode).forEach((btn) => {
  btn.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      const btn = e.currentTarget;
      const gridMode = btn.getAttribute("data-grid-mode");

      if (!btn.classList.contains("actived")) {
        document
          .querySelectorAll(options.gridMode)
          .forEach((modeBtn) => modeBtn.classList.remove("actived"));
        const container = document.querySelector(".container-products-switch");
        const currentViewMode = container.getAttribute("data-view-mode");

        btn.classList.add("actived");
        container.classList.remove(`grid-columns-${currentViewMode}`);
        container.setAttribute("data-view-mode", gridMode);
        container.classList.add(`grid-columns-${gridMode}`);
      }
    },
    false
  );
});

//Active class toggle in filter option
const selectElement = document.querySelector(".select__select");

if (selectElement) {
  const parentDiv = selectElement.closest(".facet-filters__field");

  if (parentDiv) {
    selectElement.addEventListener("click", function () {
      // Toggle the active class on both the select element and its parent div
      selectElement.classList.toggle("active");
      parentDiv.classList.toggle("active");
    });

    selectElement.addEventListener("change", function () {
      // Ensure the active class is added to both when an option is selected
      selectElement.classList.add("active");
      parentDiv.classList.add("active");
    });

    selectElement.addEventListener("blur", function () {
      // Remove the active class from both when the select element loses focus
      selectElement.classList.remove("active");
      parentDiv.classList.remove("active");
    });
  }
}

//video section

document.addEventListener("DOMContentLoaded", () => {
  const videoSection = document.querySelector(".video-section");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          entry.target.classList.add("active");
        } else if (!entry.isIntersecting && entry.boundingClientRect.top > 0) {
          entry.target.classList.remove("active");
        }
      });
    },
    {
      threshold: [0, 0.3, 1.0],
    }
  );

  observer.observe(videoSection);
});

//faq

document.addEventListener("DOMContentLoaded", function () {
  const categoryLinks = document.querySelectorAll(".categories-item");

  categoryLinks.forEach((link, index) => {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default anchor link behavior

      const targetId = this.getAttribute("data-id").replace("#", ""); // Remove the hash symbol
      const targetElement = document.getElementById(targetId); // Use getElementById to find the target element

      if (targetElement) {
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        let offsetPosition;

        if (index === 0) {
          // Adjust scroll position by 100 pixels for the first anchor
          offsetPosition = targetPosition - 125;
        } else {
          // Adjust scroll position by 45 pixels for other anchors
          offsetPosition = targetPosition - 60;
        }

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});

//video autoplay

document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll(".autoplay-video");
  videos.forEach(function (video) {
    video.play().catch(function (error) {
      console.log("Video autoplay failed:", error);
    });
  });
});

document.addEventListener("visibilitychange", function () {
  var videos = document.querySelectorAll(".autoplay-video");
  videos.forEach(function (video) {
    if (document.visibilityState === "visible") {
      video.play().catch(function (error) {
        console.log("Video playback failed:", error);
      });
    } else {
      video.pause();
    }
  });
});

//drawer caret js
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("summary.menu-drawer__menu-item")
    .forEach(function (summary) {
      summary.addEventListener("click", function () {
        summary.classList.toggle("active");
      });
    });
});

//announcement drawer close js
document
  .getElementById("close_mobile_drawer")
  .addEventListener("click", function () {
    document.querySelector(".mobile_menu_summary").click();
  });

// reveiw slide js
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    let hasReview = document.querySelector(".review-sold-out-wrapper");
    if (hasReview) {
      let reviewBtn = hasReview.querySelector(".shopify-app-block .jdgm-widget");
      let reviewBlock = document.querySelector(".bls__product-tabs ");
      if (reviewBtn && reviewBlock) {
        reviewBtn.addEventListener("click", function (event) {
          let reviewTabBtn = reviewBlock.querySelector(".reviews_btn_class");
          if (!reviewTabBtn.classList.contains("active")) {
            reviewTabBtn.click();
          }
        });
      }
    }
  }, 700);
});

//gift wrap option


document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.querySelector('.product-gift-checkbox');
  const inputProperty = document.querySelector('.giftWrappingProduct');
  const variantOptions = document.getElementById('variant-options');

  checkbox.addEventListener('change', function() {
    if (this.checked) {
      variantOptions.style.display = 'block';
    } else {
      variantOptions.style.display = 'none';
    }
  });

  variantOptions.addEventListener('click', function(event) {
    const variantOption = event.target.closest('.variant-option');

    if (variantOption) {
      const selectedVariantId = variantOption.getAttribute('data-variant-id');
      const selectedVariantTitle = variantOption.getAttribute('data-variant-name');

      const previouslySelected = variantOptions.querySelector('.variant-option.selected');
      if (previouslySelected) {
        previouslySelected.classList.remove('selected');
      }

      variantOption.classList.add('selected');

      checkbox.value = selectedVariantId;
      checkbox.value = selectedVariantId;
      inputProperty.value = selectedVariantTitle;
      checkbox.checked = true;
      
    }
  });
});

function removeTdOnMobile() {
  const lastTd = document.getElementById('last_td');
  
  if (window.innerWidth <= 750) {
    if (lastTd) {
      lastTd.remove();  // Completely remove the <td> element
    }
  }
}

// Check on page load
window.addEventListener('load', removeTdOnMobile);

// Check whenever the window is resized
window.addEventListener('resize', function() {
  // Only run the remove function once when resizing below 750px
  if (window.innerWidth <= 750 && document.getElementById('last_td')) {
    removeTdOnMobile();
  }
});


//Trade up checkboc of product page

document.addEventListener('DOMContentLoaded', function() {
  document.getElementById('trade-up-checkbox').addEventListener('change', function() {
    // Get the spans
    const tradeUpLocation = document.querySelector('.trade-up-location');
    const tradeUpDiscount = document.querySelector('.trade-up-discount');
  
    if (this.checked) {
      // Checkbox is checked
      tradeUpLocation.style.display = 'none'; // Hide trade-up-location
      tradeUpDiscount.style.display = 'inline'; // Show trade-up-discount
      this.classList.add('active'); // Add the active class
      this.value = 'Yes';
    } else {
      // Checkbox is unchecked
      tradeUpLocation.style.display = 'inline'; // Show trade-up-location
      tradeUpDiscount.style.display = 'none'; // Hide trade-up-discount
      this.classList.remove('active'); // Remove the active class
      this.value = 'No';
    }
  });
});
